import { render } from "./k-icon-picker.vue?vue&type=template&id=aa401aa2&scoped=true"
import script from "./k-icon-picker.vue?vue&type=script&lang=js"
export * from "./k-icon-picker.vue?vue&type=script&lang=js"

import "./k-icon-picker.vue?vue&type=style&index=0&id=aa401aa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa401aa2"]])

export default __exports__